import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Comparison } from 'listings/components/comparison-version-selector/comparison-version-selector.component';
import { ComparisonType } from 'settings/enums/comparison.enum';
import { FeatureGroup } from 'shared/interfaces/feature-group.interface';
import { ToastService } from 'shared/services';

const LISTING_SNAPSHOTS_API = environment.BASE_URL + 'listingApi/snapshots/';

@Injectable({
    providedIn: 'root',
})
export class ListingComparisonService {
    constructor(private toastService: ToastService) {}

    public prepareComparisonObject(
        comparisonData: any,
        outletId: string | undefined,
        featureGroupName: string,
        changedFeatureGroupsList: FeatureGroup[],
        version?: number,
        channelCompare?: string,
        comparisonType: ComparisonType = ComparisonType.VERSION,
    ): Comparison {
        let comparisonObject: Comparison;
        let data: any = null;

        if (outletId) {
            if (version === undefined || comparisonType === ComparisonType.CHANNEL) {
                data = comparisonData[featureGroupName!]?.[featureGroupName!];
            } else {
                const outlet = comparisonData?.outlet?.outlet;

                if (Array.isArray(outlet) && outlet.length) {
                    data = outlet.find((outlet: any) => outlet.outletId === outletId)?.[featureGroupName];
                } else {
                    this.toastService.showToast('listing.version.noOutlet', 'warning', undefined, 4000);
                    comparisonObject = {
                        data: false,
                        currentFeatureGroup: featureGroupName!,
                        currentVersion: version,
                        channelCompare: channelCompare,
                        changedFeatureGroups: [],
                        comparisonType: comparisonType || ComparisonType.VERSION,
                    } as Comparison;

                    return comparisonObject;
                }
            }
        } else {
            data = comparisonData[featureGroupName!]?.[featureGroupName!];
        }

        comparisonObject = {
            data: data ?? {},
            currentFeatureGroup: featureGroupName!,
            currentVersion: version,
            channelCompare: channelCompare,
            changedFeatureGroups: changedFeatureGroupsList,
            comparisonType: comparisonType || ComparisonType.VERSION,
        } as Comparison;

        return comparisonObject;
    }
}
